import { useCallback } from 'react'
import useFeature, { features } from '@/hooks/useFeature'

/**
 * The router state that tells a submittal's detail page which data element it
 * was listed on, or `undefined` when there is nothing to say.
 *
 * Only the listing names the element in its path. A detail page belongs to one
 * just as much but says so nowhere, so without this the sidebar highlight would
 * vanish the moment a row is opened — which the single Submittals link never did,
 * since every sub-page sat under its URL.
 *
 * Named `tabId` to match pitstop-ui, which writes the same key for the same
 * reason; the two sidebars read the same state.
 *
 * Gated on SUBMITTALS_PHASE_2 because there is nothing to highlight without it:
 * the flag-off build has a single unscoped listing behind a single nav link.
 */
const useListingTabState = () => {
  const isPhase2 = useFeature(features.SUBMITTALS_PHASE_2)

  return useCallback(
    dataElementId => (isPhase2 && dataElementId ? { tabId: dataElementId } : undefined),
    [isPhase2]
  )
}

export default useListingTabState
